import { Spin, notification, Input, Divider } from "antd";
import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import "./Login.css";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import Countdown from "react-countdown";
import { SendOtpApi, VerifyOtpApi } from "../../Services/Login";
import djtLogo from "../../Assets/Images/logo.png";
import backgroundImage from "../../Assets/Images/bgLogin.png";
import Cookies from "js-cookie";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 18, color: "white" }} spin />
);

const maskEmail = (email) => {
  if (!email) return "";

  const [username, domain] = email.split("@");
  if (!username || !domain) return email;

  const maskedUsername =
    username.length <= 2
      ? username.charAt(0) + "*".repeat(username.length - 1)
      : username.charAt(0) +
      "*".repeat(Math.min(username.length - 2, 3)) +
      username.charAt(username.length - 1);

  return `${maskedUsername}@${domain}`;
};

export default function Login() {
  const [api, contextHolder] = notification.useNotification();

  const navigate = useNavigate(null);

  const [isOtp, setIsOtp] = useState(
    localStorage.getItem("isOtp") !== undefined
      ? localStorage.getItem("isOtp") === "true"
        ? true
        : false
      : false
  );
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  const [emailSpin, setEmailSpin] = useState(false);
  const [resendSpin, setResendSpin] = useState(false);
  const [otpSpin, setOtpSpin] = useState(false);

  const [emailErrorMessage, setEmailErrorMessage] = useState(null);
  const [otpErrorMessage, setOtpErrorMessage] = useState(null);

  const emailRef = useRef(null);
  const otpRefs = useRef([]);

  const [currentDate, setCurrentDate] = useState("");
  const [countdownKey, setCountdownKey] = useState(1);
  const [loginType, setLoginType] = useState("EMPLOYEE");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailErrorMessage(null);
  };

  const handleOtpChange = (index, value) => {
    // Only allow digits
    if (value && !/^\d$/.test(value)) {
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setOtpErrorMessage(null);

    // Auto-focus next input
    if (value && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }

    // Handle enter key on last digit
    if (
      e.key === "Enter" &&
      index === 5 &&
      otp.every((digit) => digit !== "")
    ) {
      handleVerifyOtp();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    // Only process if it's 4 digits
    if (/^\d{6}$/.test(pastedData)) {
      const newOtp = pastedData.split("");
      setOtp(newOtp);
      // Focus the last input
      otpRefs.current[5]?.focus();
    }
  };

  const handleSendOtp = async () => {
    try {
      setEmailSpin(true);
      const data = await SendOtpApi(email, loginType);
      setEmailSpin(false);

      if (data.data.success) {
        setIsOtp(true);
        localStorage.setItem("email", email);
        localStorage.setItem("isOtp", true);
      } else {
        setEmailErrorMessage(data.data.message);
      }
    } catch (err) {
      setEmailSpin(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const handleResendOtp = async () => {
    try {
      setResendSpin(true);
      const data = await SendOtpApi(localStorage?.getItem("email"), loginType);
      setResendSpin(false);

      if (data.data.success) {
        setCountdownKey(countdownKey + 1);
        setOtp(["", "", "", "", "", ""]);
        otpRefs.current[0]?.focus();
      } else {
        setOtpErrorMessage(data.data.message);
      }
    } catch (err) {
      setResendSpin(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection",
        placement: "top",
      });
    }
  };

  const handleVerifyOtp = async () => {
    const otpString = otp.join("");

    if (otpString.length !== 6) {
      return;
    }

    try {
      setOtpSpin(true);
      const data = await VerifyOtpApi(
        localStorage?.getItem("email"),
        otpString
      );
      setOtpSpin(false);

      console.log(data);

      if (data.data.success) {
        localStorage.removeItem("email");
        localStorage.setItem("isOtp", false);

        localStorage.setItem("firstName", data.data.data.name.first_name);
        localStorage.setItem("middleName", data.data.data.name.middle_name);
        localStorage.setItem("lastName", data.data.data.name.last_name);
        localStorage.setItem("fullName", data.data.data.name.full_name);

        localStorage.setItem("personalEmail", data.data.data.email.personal);
        localStorage.setItem("companyEmail", data.data.data.email.company);
        localStorage.setItem("userId", data.data.data._id);

        localStorage.setItem("isLoggedIn", "true");

        // Update component state so UI exits OTP mode immediately
        setIsOtp(false);

        // Mark as new user if applicable
        if (loginType === "EMPLOYEE") {
          if (data.data.data.new_user || data?.data?.data?.migrated) {
            localStorage.setItem("userType", "newUser");
          }
        }

        // Navigate to authenticated welcome so App's auth state is picked up
        navigate("/employee/welcome");
      } else {
        setOtpErrorMessage(data.data.message);
      }
    } catch (err) {
      setOtpSpin(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection",
        placement: "top",
      });
    }
  };

  const handleChangeEmailButton = () => {
    setEmail("");
    setIsOtp(false);
    setOtp(["", "", "", "", "", ""]);
    localStorage.setItem("email", "");
    localStorage.setItem("isOtp", false);
  };

  const renderer = ({ hours, minutes, seconds, completed, api, props }) => {
    if (completed) {
      return (
        <button
          className={` text-blue-600`}
          onClick={handleResendOtp}
          disabled={otpSpin || resendSpin}
        >
          {resendSpin && <Spin indicator={antIcon} spinning={resendSpin} />}
          Resend OTP
        </button>
      );
    } else {
      if (seconds === 0 && minutes === 0) {
        props.date = props.date + 120000;
      }
      api.start();
      return (
        <button className=" text-gray-500" disabled>
          {`Resend OTP in ${minutes > 9 ? minutes : "0" + minutes}:${seconds > 9 ? seconds : "0" + seconds
            }`}
        </button>
      );
    }
  };

  return (
    <>
      {contextHolder}

      <div className="login-container">
        <div className="login-background">
          <img src={backgroundImage} alt="" />
        </div>

        <div className="login-content">
          <div className="login-logo">
            <img src={djtLogo} alt="DJT Corporation & Investments" />
          </div>
          {/* Login Card */}
          <div className="login-card">
            {/* Logo */}

            {/* Welcome Text */}
            {!isOtp ? (
              <>
                <h1 className="login-title">Welcome to DJT People</h1>
                <p className="login-subtitle">Sign in with your mail id</p>
              </>
            ) : (
              <>
                <h1 className="login-title">Verify your email</h1>
                <p className="login-subtitle">
                  We've sent a 6-digit verification code to
                </p>
                <p className="login-email-display">
                  {maskEmail(localStorage.getItem("email"))}
                </p>
              </>
            )}

            {/* Form Container */}
            <div className="login-form">
              {!isOtp ? (
                <>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Email ID<span className="required">*</span>
                    </label>
                    <Input
                      id="email"
                      onKeyDown={(e) =>
                        e.key === "Enter"
                          ? email.length !== 0
                            ? emailRef.current.input.validity.valid
                              ? handleSendOtp()
                              : ""
                            : ""
                          : ""
                      }
                      ref={emailRef}
                      type="email"
                      disabled={emailSpin}
                      prefix={<MailOutlined style={{ color: "#999" }} />}
                      placeholder="Enter your personal email ID"
                      size="large"
                      className="custom-input"
                      onChange={(e) => handleEmailChange(e)}
                    />
                    {email.length === 0 ? (
                      <span className="error-message">
                        Please enter your email.
                      </span>
                    ) : !emailRef.current.input.validity.valid ? (
                      <span className="error-message">
                        Please enter valid email.
                      </span>
                    ) : emailErrorMessage !== null ? (
                      <span className="error-message">{emailErrorMessage}</span>
                    ) : null}
                  </div>

                  <button
                    className="continue-button"
                    onClick={handleSendOtp}
                    disabled={
                      email.length === 0 || emailSpin
                        ? true
                        : emailRef.current.input.validity.valid
                          ? false
                          : true
                    }
                  >
                    {emailSpin && (
                      <Spin indicator={antIcon} spinning={emailSpin} />
                    )}
                    {emailSpin ? "Sending..." : "Continue with OTP"}
                  </button>
                </>
              ) : (
                <>
                  <div className="form-group">
                    <div className="otp-input-container">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          ref={(el) => (otpRefs.current[index] = el)}
                          type="text"
                          inputMode="numeric"
                          maxLength={1}
                          value={digit}
                          onChange={(e) =>
                            handleOtpChange(index, e.target.value)
                          }
                          onKeyDown={(e) => handleOtpKeyDown(index, e)}
                          onPaste={index === 0 ? handleOtpPaste : undefined}
                          disabled={otpSpin || resendSpin}
                          className="otp-input-box"
                          autoFocus={index === 0}
                        />
                      ))}
                    </div>
                    {otpErrorMessage !== null && (
                      <span className="error-message">{otpErrorMessage}</span>
                    )}
                  </div>

                  <button
                    className="continue-button"
                    onClick={handleVerifyOtp}
                    disabled={
                      otp.every((digit) => digit !== "") &&
                        !otpSpin &&
                        !resendSpin
                        ? false
                        : true
                    }
                  >
                    {otpSpin && <Spin indicator={antIcon} spinning={otpSpin} />}
                    {otpSpin ? "Verifying..." : "Continue with OTP"}
                  </button>
                  <div className="flex flex-col md:flex-row gap-3 justify-between mt-3">
                    <button
                      className="change-email-button"
                      onClick={handleChangeEmailButton}
                      disabled={otpSpin || resendSpin}
                    >
                      Change Email
                    </button>

                    <Countdown
                      date={currentDate + 120000}
                      key={countdownKey}
                      renderer={renderer}
                      onMount={() => setCurrentDate(Date.now())}
                    />
                  </div>
                </>
              )}
            </div>
            <Divider />

            <div className="terms-section">
              <span className="terms-text">By continuing, I agree to the </span>
              <span className="terms-link cursor-pointer">
                <Link to="/tnc" className="text-blue-600 underline">
                  Terms & Conditions
                </Link>
              </span>
              <span className="terms-text"> and </span>
              <span className="terms-link cursor-pointer">
                <Link to="/privacy-policy" className="text-blue-600 underline">
                  Privacy Policy
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Footer - Outside the card, positioned at bottom right */}
      <div className="login-footer">© DJT Corporation & Investments</div>
    </>
  );
}
